export const TICKET_COMMON_TYPES = ['141', '241', '217']

export const TICKET_SPECIFIC_TYPES = [
	'280',
	'178',
	'281',
	'282',
	'283',
	'284',
	'285',
]
